// Module
var code = "<ng-include src=\"$ctrl.getPartial()\"></ng-include> ";
// Exports
module.exports = code;